(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpv-quick-order"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lpv-quick-order')) {
  customElements.define('lpv-quick-order', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.t = JSON.parse(this.querySelector('[data-text]').content.textContent);
      this.root = this.dataset.root;
      this.currency = this.dataset.currency;
      this.key = 'lpv-quick-order-v1-' + this.currency;
      this.pendingKey = this.key + '-pending';
      this.money = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.currency });
      this.products = new Map(); this.variants = new Map(); this.selection = new Map(); this.limit = 30;
      this.search = this.querySelector('[data-search]'); this.family = this.querySelector('[data-family]'); this.maker = this.querySelector('[data-maker]');
      this.rows = this.querySelector('[data-rows]'); this.selectedRows = this.querySelector('[data-selected]'); this.status = this.querySelector('[data-status]');
      this.addEventListener('input', e => { if (e.target === this.search) { this.limit = 30; this.renderRows(); } });
      this.addEventListener('change', e => this.change(e));
      this.addEventListener('click', e => this.click(e));
      this.watchPreview();
      this.load();
    }
    watchPreview() {
      const update = () => {
        const bar = document.getElementById('PBarNextFrameWrapper');
        const rect = bar?.getBoundingClientRect();
        this.style.setProperty('--lpv-q-preview', (rect && rect.height > 0 ? Math.max(0, innerHeight - rect.top) : 0) + 'px');
      };
      const find = () => {
        const bar = document.getElementById('PBarNextFrameWrapper'); if (!bar) return;
        this.previewWatch?.disconnect(); clearTimeout(this.previewTimer);
        this.previewResize = new ResizeObserver(update); this.previewResize.observe(bar); update();
      };
      this.previewWatch = new MutationObserver(find); this.previewWatch.observe(document.body, { childList: true, subtree: true });
      this.previewTimer = setTimeout(() => this.previewWatch.disconnect(), 15000); this.previewUpdate = update;
      window.addEventListener('resize', update); find();
    }
    disconnectedCallback() {
      this.previewWatch?.disconnect(); this.previewResize?.disconnect(); clearTimeout(this.previewTimer);
      window.removeEventListener('resize', this.previewUpdate);
    }
    textValue(v) { return Array.isArray(v) ? v.join(', ') : String(v || ''); }
    norm(s) { return this.textValue(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]/gu, ''); }
    el(tag, text, cls) { const e = document.createElement(tag); if (text !== undefined) e.textContent = text; if (cls) e.className = cls; return e; }
    read(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; } }
    write(key, value) { try { value === null ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(value)); } catch {} }
    save() { this.write(this.key, [...this.selection].map(([id, quantity]) => ({ id, quantity }))); }
    notice(text, error = false) { this.status.textContent = text; this.status.classList.toggle('lpv-q-error', error); }
    ingest(data) {
      for (const p of data.products) {
        p.maker = this.textValue(p.maker).trim();
        p.search = this.norm([p.title, p.maker, p.cas, p.synonyms, p.handle].join(' '));
        p.variants.forEach(v => { v.id = String(v.id); this.variants.set(v.id, { p, v }); });
        this.products.set(String(p.id), p);
      }
    }
    async load() {
      this.querySelector('[data-retry]').hidden = true;
      try {
        let data = JSON.parse(this.querySelector('[data-catalogue]').content.textContent);
        this.ingest(data);
        while (data.next) {
          const url = new URL(this.root + 'collections/all', location.origin);
          url.searchParams.set('section_id', 'lpv-quick-order-data'); url.searchParams.set('page', String(data.next)); url.searchParams.set('sort_by', data.sort || 'title-ascending');
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error();
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          data = JSON.parse(doc.querySelector('[data-catalogue]').content.textContent); this.ingest(data);
        }
        const makers = [...new Set([...this.products.values()].map(p => p.maker).filter(Boolean))].sort((a, b) => a.localeCompare(b));
        this.maker.replaceChildren(new Option(this.t.all_makers, ''));
        makers.forEach(m => this.maker.add(new Option(m, m)));
        let stale = false;
        for (const item of this.read(this.key) || []) {
          const pair = this.variants.get(String(item.id));
          if (pair && pair.v.available && Number.isSafeInteger(item.quantity) && item.quantity > 0) {
            const quantity = Math.min(item.quantity, pair.v.max ?? 9999); this.selection.set(String(item.id), quantity); if (quantity !== item.quantity) stale = true;
          } else stale = true;
        }
        this.ready = true; this.querySelector('[data-filters]').disabled = false;
        this.notice(stale ? this.t.updated_selection : ''); this.renderRows(); this.renderSelection();
        if (this.read(this.pendingKey)) { this.uncertain = true; this.renderSelection(); await this.recover(); }
      } catch { this.notice(this.t.load_error, true); this.querySelector('[data-retry]').hidden = false; }
    }
    unit(v) {
      const match = v.title.trim().replace(',', '.').match(/^(\d+(?:\.\d+)?)\s*(kg|g|ml|l)$/i);
      if (!match || Number(match[1]) <= 0) return '';
      const u = match[2].toLowerCase(); const amount = Number(match[1]) * (u === 'kg' || u === 'l' ? 1000 : 1);
      return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: this.currency, minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(v.price / 100 / amount) + '/' + (u === 'g' || u === 'kg' ? 'g' : 'ml');
    }
    priceBlock(v) { const box = this.el('div', undefined, 'lpv-q-price'); box.append(this.el('strong', this.money.format(v.price / 100)), this.el('small', this.unit(v))); return box; }
    renderRows() {
      if (!this.ready) return;
      const tokens = this.search.value.trim().split(/\s+/).map(s => this.norm(s)).filter(Boolean);
      const availableOnly = this.querySelector('[data-stock]').checked;
      const products = [...this.products.values()].filter(p => tokens.every(t => p.search.includes(t)) && (!this.family.value || p.families.includes(this.family.value)) && (!this.maker.value || p.maker === this.maker.value) && (!availableOnly || p.variants.some(v => v.available))).sort((a, b) => a.title.localeCompare(b.title, document.documentElement.lang));
      this.querySelector('[data-count]').textContent = products.length + ' ' + (products.length === 1 ? this.t.material_one : this.t.materials);
      this.rows.replaceChildren();
      for (const p of products.slice(0, this.limit)) {
        const row = this.el('li', undefined, 'lpv-q-row'); row.dataset.product = String(p.id);
        const name = this.el('div', undefined, 'lpv-q-name'); const link = this.el('a', p.title.split(/ [–—] /)[0]); link.href = p.url; name.append(link);
        if (p.maker) name.append(this.el('small', p.maker));
        const controls = this.el('div', undefined, 'lpv-q-controls');
        const select = this.el('select'); select.dataset.variant = ''; select.setAttribute('aria-label', this.t.format + ': ' + link.textContent);
        const selectedId = p.selectedId || p.variants.find(v => v.available)?.id || p.variants[0]?.id;
        for (const v of p.variants) { const option = new Option(v.title + (v.available ? '' : ' · ' + this.t.sold_out), v.id); option.disabled = !v.available; option.selected = v.id === selectedId; select.add(option); }
        const v = p.variants.find(v => v.id === selectedId); if (!v) continue;
        const qty = this.el('input'); qty.type = 'number'; qty.min = '1'; qty.step = '1'; qty.max = String(v.max ?? 9999); qty.value = '1'; qty.inputMode = 'numeric'; qty.dataset.quantity = ''; qty.setAttribute('aria-label', this.t.quantity + ': ' + link.textContent); qty.disabled = !v.available;
        const button = this.el('button', this.t.select, 'button button--secondary'); button.type = 'button'; button.dataset.select = ''; button.disabled = !v.available; button.setAttribute('aria-label', this.t.select + ': ' + link.textContent);
        const price = this.priceBlock(v); price.dataset.rowPrice = '';
        controls.append(select, qty, price, button); row.append(name, controls); this.rows.append(row);
      }
      this.querySelector('[data-empty]').hidden = products.length > 0;
      this.querySelector('[data-more]').hidden = products.length <= this.limit;
    }
    renderSelection() {
      const focused = document.activeElement; const activeId = this.contains(focused) ? focused?.dataset?.selectedQty : null;
      this.selectedRows.replaceChildren(); let total = 0, units = 0;
      for (const [id, quantity] of this.selection) {
        const { p, v } = this.variants.get(id); total += v.price * quantity; units += quantity;
        const row = this.el('li', undefined, 'lpv-q-chosen');
        const title = p.title.split(/ [–—] /)[0]; const info = this.el('div'); info.append(this.el('strong', title), this.el('small', v.title + ' · ' + this.money.format(v.price / 100)));
        const qty = this.el('input'); qty.type = 'number'; qty.min = '1'; qty.step = '1'; qty.max = String(v.max ?? 9999); qty.value = String(quantity); qty.inputMode = 'numeric'; qty.dataset.selectedQty = id; qty.setAttribute('aria-label', this.t.quantity + ': ' + title + ' ' + v.title); qty.disabled = this.busy || this.uncertain;
        const remove = this.el('button', '×', 'lpv-q-remove'); remove.type = 'button'; remove.dataset.remove = id; remove.setAttribute('aria-label', this.t.remove + ': ' + title + ' ' + v.title); remove.disabled = this.busy || this.uncertain;
        row.append(info, qty, remove); this.selectedRows.append(row);
      }
      this.querySelector('[data-selection-empty]').hidden = this.selection.size > 0;
      this.querySelectorAll('[data-total]').forEach(e => e.textContent = this.money.format(total / 100));
      this.querySelectorAll('[data-selection-count]').forEach(e => e.textContent = this.selection.size + ' ' + (this.selection.size === 1 ? this.t.line_one : this.t.lines) + ' · ' + units + ' ' + (units === 1 ? this.t.unit_one : this.t.units));
      const button = this.querySelector('[data-cart-add]'); button.disabled = !this.selection.size || this.busy || this.uncertain; button.textContent = this.busy ? this.t.adding : this.t.add_all;
      this.querySelector('[data-recover]').hidden = !this.uncertain || this.busy;
      this.querySelector('[data-mobile-summary]').hidden = !this.selection.size;
      this.querySelectorAll('[data-select]').forEach(e => e.disabled = this.busy || this.uncertain || !this.variants.get(e.closest('[data-product]').querySelector('[data-variant]').value)?.v.available);
      if (activeId) this.querySelector('[data-selected-qty="' + activeId + '"]')?.focus({ preventScroll: true });
    }
    change(e) {
      if ([this.family, this.maker, this.querySelector('[data-stock]')].includes(e.target)) { this.limit = 30; this.renderRows(); this.renderSelection(); }
      if (e.target.matches('[data-variant]')) {
        const row = e.target.closest('[data-product]'); const { p, v } = this.variants.get(e.target.value); p.selectedId = v.id;
        const price = this.priceBlock(v); price.dataset.rowPrice = ''; row.querySelector('[data-row-price]').replaceWith(price);
        const qty = row.querySelector('[data-quantity]'); qty.max = String(v.max ?? 9999); qty.value = '1';
      }
      if (e.target.matches('[data-selected-qty]') && !this.busy && !this.uncertain) {
        if (!e.target.reportValidity()) return;
        this.selection.set(e.target.dataset.selectedQty, Number(e.target.value)); this.save(); this.renderSelection();
      }
    }
    click(e) {
      const button = e.target.closest('button'); if (!button || !this.contains(button)) return;
      if (button.matches('[data-retry]')) this.load();
      if (button.matches('[data-more]')) { this.limit += 30; this.renderRows(); this.renderSelection(); }
      if (button.matches('[data-recover]')) this.recover();
      if (button.matches('[data-cart-add]')) this.addToCart();
      if (this.busy || this.uncertain) return;
      if (button.matches('[data-remove]')) { this.selection.delete(button.dataset.remove); this.save(); this.renderSelection(); }
      if (button.matches('[data-select]')) {
        const row = button.closest('[data-product]'); const id = row.querySelector('[data-variant]').value; const qty = row.querySelector('[data-quantity]');
        if (!qty.reportValidity()) return;
        const { p, v } = this.variants.get(id); const quantity = (this.selection.get(id) || 0) + Number(qty.value);
        if (v.max !== null && quantity > v.max) { this.notice(this.t.stock_limit.replace('__COUNT__', String(v.max)), true); return; }
        this.selection.set(id, quantity); this.save(); this.renderSelection(); this.notice(p.title.split(/ [–—] /)[0] + ' · ' + v.title + ' — ' + this.t.selected);
      }
    }
    async cart() { const r = await fetch(this.root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }); if (!r.ok) throw new Error(); return r.json(); }
    counts(cart) { const counts = {}; for (const i of cart.items) counts[i.variant_id] = (counts[i.variant_id] || 0) + i.quantity; return counts; }
    reconcile(pending, cart) {
      const now = this.counts(cart); let complete = true;
      for (const item of pending.items) {
        const added = Math.max(0, (now[item.id] || 0) - (pending.before[item.id] || 0)); const remaining = Math.max(0, item.quantity - added);
        remaining ? this.selection.set(String(item.id), remaining) : this.selection.delete(String(item.id)); if (remaining) complete = false;
      }
      this.save(); this.write(this.pendingKey, null); this.uncertain = false;
      return complete;
    }
    async recover() {
      const pending = this.read(this.pendingKey); if (!pending) { this.uncertain = false; this.renderSelection(); return; }
      this.busy = true; this.renderSelection();
      try { const complete = this.reconcile(pending, await this.cart()); this.notice(complete ? this.t.recovered : this.t.partial, !complete); }
      catch { this.uncertain = true; this.notice(this.t.uncertain, true); }
      finally { this.busy = false; this.renderSelection(); }
    }
    async addToCart() {
      if (this.busy || this.uncertain || !this.selection.size) return;
      if (![...this.querySelectorAll('[data-selected-qty]')].every(e => e.reportValidity())) return;
      this.busy = true; this.renderSelection(); this.notice(''); let pending;
      try {
        const before = await this.cart(); pending = { before: this.counts(before), items: [...this.selection].map(([id, quantity]) => ({ id, quantity })) };
        this.write(this.pendingKey, pending);
        let serverError = '';
        try { const r = await fetch(this.root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: pending.items }) }); const data = await r.json(); if (!r.ok) serverError = this.textValue(data.description || data.message); } catch { serverError = this.t.connection_error; }
        const cart = await this.cart(); const complete = this.reconcile(pending, cart);
        if (complete) { location.assign(this.root + 'cart'); return; }
        this.notice((serverError ? serverError + ' ' : '') + this.t.partial, true);
      } catch {
        this.uncertain = !!pending; this.notice(pending ? this.t.uncertain : this.t.connection_error, true);
      } finally { this.busy = false; this.renderSelection(); }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
